<template>
    <CCard>    
        <CCardBody>  
            <CCol sm="12" lg="12" style="padding-left: 0px; padding-right: 0px;">  
                <div class="content-wrapper">
                    <div id="app">
                        <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                            <ejs-grid ref='refdata' :dataSource='datas' height='60vh' 
                                :allowExcelExport='true' :allowPaging='true' :allowSorting='true' :allowFiltering='true' :allowReordering='true' :allowSelection='true'
                                :toolbar='toolbar' :pageSettings='pageSettings' :filterSettings='filterSettings' :selectionSettings='selectionSettings' :toolbarClick="toolbarClick"
                                :editSettings='editSettings' :beforeRender="beforeRender" 
                                :queryCellInfo='onQueryCellInfo' :rowDataBound="onRowDataBound">
                                <e-columns>          
                                  <e-column type='checkbox' :allowFiltering='false' :allowSorting='false' width='60'></e-column>                                                      
                                  <e-column field='id' headerText='接收ID' width='0' :isPrimaryKey='true'  ></e-column>         
                                  <e-column field='is_close' headerText='背景執行完畢' width='160'></e-column>          
                                  <e-column field='create_date' headerText='建檔日期' width='180'></e-column>  
                                  <e-column field='type' headerText='類型' width='160'></e-column>       
                                  <e-column field='request' headerText='接收訊息' width='320'></e-column>
                                                              
                                </e-columns>                              
                            </ejs-grid>
                        </ejs-tooltip>
                    </div>
                </div>
            </CCol>
            <ejs-toast ref='toastRef' id='toast_type' :position='position'></ejs-toast>      
        </CCardBody>
    </CCard>  
</template>



<style lang="scss" src="../../scss/grid.scss"></style>
<script lang="ts">

import Vue from "vue";
import Loading from 'vue-loading-overlay';
import { DialogUtility } from '@syncfusion/ej2-popups';
import { ToastComponent } from "@syncfusion/ej2-vue-notifications";
import { L10n, setCulture, enableRipple } from '@syncfusion/ej2-base';
import { DialogPlugin, TooltipPlugin } from '@syncfusion/ej2-vue-popups';
import { GridPlugin, DetailRow, PdfExport, ExcelExport, Sort, Edit, Page, Filter, Reorder, Toolbar, Search } from "@syncfusion/ej2-vue-grids";


setCulture('en-US');
L10n.load({
  'en-US': {
    'pager': {
      'currentPageInfo': '',
      'totalItemsInfo': '{1} to {2} of {0}',
    },
    'grid': {
        'Print': '列印',
        'Search': '搜尋'
    }
  }
});

enableRipple(true);
Vue.use(DialogPlugin);
Vue.use(TooltipPlugin);
Vue.use(GridPlugin);
Vue.use(Loading);

let DialogObj   = undefined;
let Loader      = undefined;

export default {
  name: 'Department',
  components: {   
    'ejs-toast': ToastComponent
  },
  data: function () {
    return {
      e_selectRow : null,   

      filterSettings: { type: 'CheckBox' },
      pageSettings: { pageSizes: [10, 50, 100, 200], pageCount: 4 },
      selectionSettings: { type: 'Multiple', persistSelection: true },
      editSettings: { allowEditing: false, allowAdding: false, allowDeleting: false, showAddNewRow: false },
      toolbar: [
        { text: '刪除', tooltipText: '刪除', prefixIcon: 'e-btn-icon e-delete e-icons e-icon-left', id: 'Delete' },  
        { text: '重轉', tooltipText: '重轉', prefixIcon: 'e-btn-icon e-edit e-icons e-icon-left', id: 'Edit' }, 
        { text: '重整', tooltipText: '重整', prefixIcon: 'e-btn-icon e-refresh e-icons e-icon-left', id: 'Refresh' }, 
        { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' }, 
        'Print', 'Search'], 
      datas: null,
      position: { X: 'Right', Y: "Bottom" }, ShowBtn: false,
    };
  },
  methods: {    
    toolbarClick: function (args) {
   
      if (args.item.id == 'Delete') {
        DialogObj = DialogUtility.confirm({
            title: '刪除資料',
            content: `確認是否要刪除資料嗎?`,
            okButton: {  text: '是', click: this.delOkClick },
            cancelButton: {  text: '否', click: this.delCancelClick },
            showCloseIcon: true,
            closeOnEscape: true,
            animationSettings: { effect: 'Fade' }
        });
      }  
      if (args.item.id == 'Edit') {
        DialogObj = DialogUtility.confirm({
            title: '重新執行資料',
            content: `確認是否要執行資料嗎?`,
            okButton: {  text: '是', click: this.editOkClick },
            cancelButton: {  text: '否', click: this.delCancelClick },
            showCloseIcon: true,
            closeOnEscape: true,
            animationSettings: { effect: 'Fade' }
        });
      }  
      if (args.item.id == "Refresh") {
        this.getReceiver();
      }
      if (args.item.id == "Export") {
        this.$refs.refdata.excelExport({ fileName:'系統錯誤紀錄.xlsx' });
      }   
    },   
    onQueryCellInfo(args) {     
      if (args.cell) {
        args.cell.classList.add("tooltip-cell");
        args.cell.setAttribute("title", `${args.column.headerText}: ${args.data[args.column.field]}`);
      }
    },
    onRowDataBound(args) {
      if (args.data.state == 2) {
        args.row.style.backgroundColor = "rgba(255, 229, 255, 0.8)"; // 數量少於 3，淡紅色
      } 
    },     
    editOkClick: function() {
      let grid = this.$refs.refdata.ej2Instances;
      var select_data = grid.getSelectedRecords(); // ✅ 拿到勾選的資料  

      DialogObj.hide();
      this.showLoading();
      this.axios({
          method: 'put',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'System/FullLink/Receiver',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : 
            select_data.map(x => x.id)
          
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; } 
        this.showMsg('修改成功!');         
        this.hideLoading();
        this.getReceiver();
       
      })
      .catch((error) => { this.showError(error, true) }
      ) 
    },
    delOkClick: function() {

      let grid = this.$refs.refdata.ej2Instances;
      var select_data = grid.getSelectedRecords(); // ✅ 拿到勾選的資料  

      DialogObj.hide();
      this.showLoading();
      this.axios({
          method: 'delete',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'System/FullLink/Receiver',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : 
            select_data.map(x => x.id)
          
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; } 
        this.showMsg('刪除成功!');         
        this.hideLoading();
        this.getReceiver();
       
      })
      .catch((error) => { this.showError(error, true) }
      ) 
    },           
    delCancelClick: function() {
        DialogObj.hide();
    },    
    beforeRender: function (args) {
      if (args.target.closest("td")) {
        this.$refs.tooltip.content = args.target.innerText;
      }
    },
    getReceiver: function () {           
      this.showLoading();
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'System/FullLink/Receiver',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
          this.hideLoading();         
          this.datas = response.data.datas      
          this.e_selectRow = null;

      })
      .catch((error) => { this.showError(error, true) }
      ) 
              
    },
    showError: function (error) {     
      this.hideLoading();
      if (error.response.status == 400) {
        for(var key in error.response.data.errors){      
          this.$refs.toastRef.show( { title: '警告!', content: error.response.data.errors[key][0] , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
        }
        return;
      }   
      if (error.response.status == 401) {
        localStorage.removeItem('token'); this.$router.push('/login');
        return;
      }
      this.$refs.toastRef.show( { title: '錯誤!', content: error.response.status, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
    },
    showMsg: function (msg) {
      this.$refs.toastRef.show( { title: '訊息!', content: msg, cssClass: 'e-toast-info', icon: 'e-info toast-icons' });
    },
    showLoading() {
      Loader = this.$loading.show({
        container: this.$refs.loadingContainer,
        canCancel: true, // default false
        onCancel: this.yourCallbackMethod,
        color: 'blue',
        loader: 'bars',  // spinner, dots, bars
        width: 164,
        height: 164,
        backgroundColor: 'black',
        opacity: 0.5,
        zIndex: 999,
      });
    },
    hideLoading() {
        Loader.hide();
    }
  },
  provide: {
    grid: [PdfExport, ExcelExport, Sort, DetailRow, Edit, Page, Toolbar, Filter, Reorder, Search]
  },
  created() {
    this.getReceiver();
  },
  mounted() {
  },
  beforeUpdate() {
  },
  beforeDestroy() {
  }
}
</script>
<style>
/* 設定 CustomerName 欄位的字體顏色 */
.blue-text {
  color: blue !important;
}
</style>
<style lang="scss" src="../../scss/base.scss"></style>
